import { SortingState } from "@tanstack/react-table";
import identity from "lodash/identity";
import { calculateOrderUpdate, getSelectedSort } from "PFApp/hooks/table/helpers";
import {
  ApiOrderKeyToColumnNamesFormatter,
  ColumnNameToApiOrderKeyFormatter
} from "PFApp/hooks/table/table.types";
import { OrderMeta, OrderOption, Snakify } from "PFTypes";
import { useCallback, useMemo } from "react";

type UseTableSorting = {
  metaOrder: OrderMeta | undefined;
  setParamsOrder: (order: OrderOption | undefined) => void;
  parseMetaOrderName?: ApiOrderKeyToColumnNamesFormatter;
  parseTableSortingId?: ColumnNameToApiOrderKeyFormatter;
};

export const useTableSorting = ({
  metaOrder,
  setParamsOrder,
  parseMetaOrderName = identity,
  parseTableSortingId = identity
}: UseTableSorting) => {
  const rawValue = metaOrder?.value;
  const defaultOrder = metaOrder?.defaultValue || (metaOrder as Snakify<OrderMeta>)?.default_value;

  const sorting = useMemo(
    () => getSelectedSort(rawValue, parseMetaOrderName),
    [rawValue, parseMetaOrderName]
  );

  const handleSortingChange = useCallback(
    (newSorting: SortingState) => {
      const updatedOrder = calculateOrderUpdate({
        defaultOrder,
        selectedApiOrder: rawValue,
        options: metaOrder?.options || [],
        parseTableSortingId,
        parseMetaOrderName,
        newSorting
      });
      setParamsOrder(updatedOrder);
    },
    [defaultOrder, rawValue, metaOrder?.options, parseTableSortingId, parseMetaOrderName, setParamsOrder]
  );

  return {
    sorting,
    handleSortingChange
  };
};
